/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SelectPGAEventResearchQueryVariables = {||};
export type SelectPGAEventResearchQueryResponse = {|
  +eventsForPgaResearch: ?$ReadOnlyArray<?{|
    +id: string,
    +tournament: {|
      +officialName: string
    |},
  |}>
|};
export type SelectPGAEventResearchQuery = {|
  variables: SelectPGAEventResearchQueryVariables,
  response: SelectPGAEventResearchQueryResponse,
|};
*/


/*
query SelectPGAEventResearchQuery {
  eventsForPgaResearch {
    id
    tournament {
      officialName
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "officialName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectPGAEventResearchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PGATourEventType",
        "kind": "LinkedField",
        "name": "eventsForPgaResearch",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourTournamentType",
            "kind": "LinkedField",
            "name": "tournament",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SelectPGAEventResearchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PGATourEventType",
        "kind": "LinkedField",
        "name": "eventsForPgaResearch",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourTournamentType",
            "kind": "LinkedField",
            "name": "tournament",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "30db90ad7a5d0f0c54c9a1ff60594ea4",
    "id": null,
    "metadata": {},
    "name": "SelectPGAEventResearchQuery",
    "operationKind": "query",
    "text": "query SelectPGAEventResearchQuery {\n  eventsForPgaResearch {\n    id\n    tournament {\n      officialName\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '78d7005180a71469b80ec81f98dc72d2';

module.exports = node;
